/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [商家让利账单列表↗](http://yapi.yishou.com/project/128/interface/api/34100) 的 **请求配置**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/getList`
 * @更新时间 `2022-09-07 10:10:44`
 */
const getListRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ReturnProfitBill/getList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "supply_id",
            "supply_name",
            "bill_no",
            "bill_status",
            "clearing_form",
            "is_zero_bill",
            "reporting_period[]",
            "created_at[]",
            "is_excel",
            "is_excel_sales",
            "is_excel_flowing",
        ],
        properties: {
            supply_id: { type: "string", description: "供应商id" },
            supply_name: { type: "string", description: "供应名称" },
            bill_no: { type: "string", description: "账单编号" },
            bill_status: { type: "string", description: "账单状态" },
            clearing_form: { type: "string", description: "结算方式" },
            is_zero_bill: { type: "string", description: "是否0元账单{1是 2否}" },
            "reporting_period[]": { type: "string", description: "账期数组" },
            "created_at[]": { type: "string", description: "创建时间数组" },
            is_excel: { type: "string", description: "导出列表{1是 0否}" },
            is_excel_sales: { type: "string", description: "导出销量汇总明细{1是 0否}" },
            is_excel_flowing: { type: "string", description: "导出收款流水明细{1是 0否}" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string", description: "账单id 用于操作" },
                        reporting_period: { type: "string", description: "账期" },
                        created_at: { type: "string", description: "账单生成时间" },
                        supply_id: { type: "string", description: "商家id" },
                        supply_name: { type: "string", description: "商家名称" },
                        clearing_form: { type: "string", description: "结算方式" },
                        bill_status: { type: "string", description: "账单状态 数值" },
                        amount_price: { type: "string", description: "总结算金额" },
                        deduction_price: { type: "string", description: "已抵扣/支付金额" },
                        stay_deduction_price: { type: "string", description: "待抵扣/支付金额" },
                        updated_at: { type: "string", description: "最后更新时间" },
                        remark: { type: "string", description: "商家备注 财务备注" },
                        bill_no: { type: "string", description: "账单编号" },
                        bill_status_name: { type: "string", description: "账单状态 中文" },
                    },
                    required: ["bill_status_name"],
                },
            },
        },
        required: ["list"],
    },
    requestFunctionName: "getList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [商家让利账单列表↗](http://yapi.yishou.com/project/128/interface/api/34100) 的 **请求函数**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/getList`
 * @更新时间 `2022-09-07 10:10:44`
 */
export const getList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getListRequestConfig, requestData), ...args);
};
getList.requestConfig = getListRequestConfig;
/**
 * 接口 [账单列表-批量提交↗](http://yapi.yishou.com/project/128/interface/api/34101) 的 **请求配置**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/batchBillSubmit`
 * @更新时间 `2022-09-01 16:20:12`
 */
const batchBillSubmitRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ReturnProfitBill/batchBillSubmit",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        title: "empty object",
        properties: { profit_bill_id: { type: "array", items: { type: "string" }, description: "账单id" } },
        required: ["profit_bill_id"],
    },
    responseDataJsonSchema: { type: "string" },
    requestFunctionName: "batchBillSubmit",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [账单列表-批量提交↗](http://yapi.yishou.com/project/128/interface/api/34101) 的 **请求函数**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/batchBillSubmit`
 * @更新时间 `2022-09-01 16:20:12`
 */
export const batchBillSubmit = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(batchBillSubmitRequestConfig, requestData), ...args);
};
batchBillSubmit.requestConfig = batchBillSubmitRequestConfig;
/**
 * 接口 [账单列表-批量审核↗](http://yapi.yishou.com/project/128/interface/api/34102) 的 **请求配置**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/batchBillExamine`
 * @更新时间 `2022-09-01 16:22:21`
 */
const batchBillExamineRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ReturnProfitBill/batchBillExamine",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        title: "empty object",
        properties: { profit_bill_id: { type: "array", items: { type: "string" }, description: "账单id" } },
        required: ["profit_bill_id"],
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "batchBillExamine",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [账单列表-批量审核↗](http://yapi.yishou.com/project/128/interface/api/34102) 的 **请求函数**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/batchBillExamine`
 * @更新时间 `2022-09-01 16:22:21`
 */
export const batchBillExamine = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(batchBillExamineRequestConfig, requestData), ...args);
};
batchBillExamine.requestConfig = batchBillExamineRequestConfig;
/**
 * 接口 [账单详情页↗](http://yapi.yishou.com/project/128/interface/api/34103) 的 **请求配置**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/getBillDetail`
 * @更新时间 `2022-09-08 19:37:03`
 */
const getBillDetailRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ReturnProfitBill/getBillDetail",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["bill_id"],
        properties: { bill_id: { type: "string", description: "账单" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            info: {
                type: "object",
                properties: {
                    bill_no: { type: "string", description: "编号" },
                    remark: { type: "string", description: "商家备注 财务备注" },
                    status: { type: "string", description: "状态值" },
                    status_msg: { type: "string", description: "状态描述" },
                    reporting_period: { type: "string", description: "账期" },
                    created_at: { type: "string", description: "生成时间" },
                    supply_id: { type: "string", description: "商家ID" },
                    supply_name: { type: "string", description: "商家name" },
                    rule_get_time: { type: "string", description: "让利计费规则获取时间" },
                    return_profit_rule: {
                        type: "array",
                        items: {
                            type: "object",
                            properties: {
                                num: { type: "string", description: "门槛" },
                                price: { type: "string", description: "单价" },
                            },
                            required: ["num", "price"],
                            description: "让利计费规则",
                        },
                        description: "让利计费规则",
                    },
                    confirm_time: { type: "string", description: "确认时间" },
                    clearing_form_type: { type: "string", description: "结算方式:{1:代采单抵扣,2:账单支付}" },
                },
                required: [
                    "bill_no",
                    "return_profit_rule",
                    "rule_get_time",
                    "supply_name",
                    "supply_id",
                    "created_at",
                    "reporting_period",
                    "status_msg",
                    "status",
                    "remark",
                    "confirm_time",
                    "clearing_form_type",
                ],
            },
            flowing: {
                type: "object",
                properties: {
                    payment_type: { type: "string", description: "支付方式" },
                    pay_create_time: { type: "string", description: "创建时间" },
                    pay_price: { type: "string", description: "支付金额" },
                    pay_time: { type: "string", description: "交易时间" },
                    brw_number: { type: "string", description: "流水" },
                    pay_status_msg: { type: "string", description: "支付状态" },
                },
                description: "流水",
            },
            goods_summary: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        goods_name: { type: "string" },
                        goods_no: { type: "string" },
                        goods_kh: { type: "string", description: "款号" },
                        stats_sale_num: { type: "string", description: "符合让利的商品销售件数" },
                        section_number: { type: "string", description: "达标区间" },
                        price: { type: "string", description: "让利单价（元/件）" },
                        return_profit_price: { type: "string", description: "让利金额（元）" },
                    },
                    required: [
                        "goods_name",
                        "price",
                        "section_number",
                        "stats_sale_num",
                        "goods_kh",
                        "goods_no",
                        "return_profit_price",
                    ],
                },
                description: "商品销量汇总表",
            },
            amount_detail: {
                type: "object",
                properties: {
                    clearing_form: { type: "string", description: "结算方式" },
                    amount_price: { type: "string", description: "总结算金额" },
                    deduction_price: { type: "string", description: "已抵扣/z支付金额" },
                    stay_deduction_price: { type: "string", description: "待抵扣/支付金额" },
                },
                required: ["clearing_form", "stay_deduction_price", "deduction_price", "amount_price"],
                description: "金额明细",
            },
            wcg_order: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        wcg_id: { type: "string", description: "代采单编号" },
                        source: { type: "string", description: "代采来源" },
                        create_time: { type: "string", description: "代采单提交时间" },
                        status: { type: "string", description: "代采单状态" },
                        deduction_price: { type: "string", description: "已抵扣金额" },
                    },
                    required: ["wcg_id", "deduction_price", "status", "create_time", "source"],
                },
                description: "代采单抵扣列表",
            },
            log: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        admin_name: { type: "string", description: "操作人" },
                        operate_type: { type: "string", description: "日志类型2时，备注可以生成快照" },
                        operate_type_msg: { type: "string", description: "操作方式" },
                        created_at: { type: "string", description: "操作时间" },
                        remark: { type: "string", description: "操作备注" },
                    },
                    required: ["admin_name", "remark", "created_at", "operate_type_msg", "operate_type"],
                },
                description: "操作日志",
            },
            sales_summary: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        section_number: { type: "string", description: "达标门槛" },
                        price: { type: "string", description: "单价" },
                        total_kh_num: { type: "string", description: "达标商品款数" },
                        total_sale_num: { type: "string", description: "达标销售件数" },
                        total_profit_price: { type: "string", description: "让利金额" },
                    },
                    required: ["section_number", "price", "total_kh_num", "total_sale_num", "total_profit_price"],
                },
                description: "销售达标汇总表",
            },
        },
        required: [
            "info",
            "field_3",
            "field_4",
            "field_5",
            "field_6",
            "sales_summary",
            "flowing",
            "amount_detail",
            "goods_summary",
            "log",
            "wcg_order",
        ],
    },
    requestFunctionName: "getBillDetail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [账单详情页↗](http://yapi.yishou.com/project/128/interface/api/34103) 的 **请求函数**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/getBillDetail`
 * @更新时间 `2022-09-08 19:37:03`
 */
export const getBillDetail = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getBillDetailRequestConfig, requestData), ...args);
};
getBillDetail.requestConfig = getBillDetailRequestConfig;
/**
 * 接口 [账单详情-导出列表↗](http://yapi.yishou.com/project/128/interface/api/34104) 的 **请求配置**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/importBillDetailList`
 * @更新时间 `2022-09-01 16:40:05`
 */
const importBillDetailListRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ReturnProfitBill/importBillDetailList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: { type: "object", required: ["bill_id"], properties: { bill_id: { type: "string" } } },
    responseDataJsonSchema: {
        type: "object",
        properties: { file: { type: "string", description: "文件" } },
        required: ["file"],
    },
    requestFunctionName: "importBillDetailList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [账单详情-导出列表↗](http://yapi.yishou.com/project/128/interface/api/34104) 的 **请求函数**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/importBillDetailList`
 * @更新时间 `2022-09-01 16:40:05`
 */
export const importBillDetailList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(importBillDetailListRequestConfig, requestData), ...args);
};
importBillDetailList.requestConfig = importBillDetailListRequestConfig;
/**
 * 接口 [账单详情-导出商品明细↗](http://yapi.yishou.com/project/128/interface/api/34105) 的 **请求配置**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/importBillGoodsDetailList`
 * @更新时间 `2022-09-01 16:39:16`
 */
const importBillGoodsDetailListRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ReturnProfitBill/importBillGoodsDetailList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        title: "empty object",
        properties: { bill_id: { type: "string" } },
        required: ["bill_id"],
    },
    responseDataJsonSchema: {
        type: "object",
        properties: { file: { type: "string", description: "文件" } },
        required: ["file"],
    },
    requestFunctionName: "importBillGoodsDetailList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [账单详情-导出商品明细↗](http://yapi.yishou.com/project/128/interface/api/34105) 的 **请求函数**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/importBillGoodsDetailList`
 * @更新时间 `2022-09-01 16:39:16`
 */
export const importBillGoodsDetailList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(importBillGoodsDetailListRequestConfig, requestData), ...args);
};
importBillGoodsDetailList.requestConfig = importBillGoodsDetailListRequestConfig;
/**
 * 接口 [账单详情-提交账单↗](http://yapi.yishou.com/project/128/interface/api/34106) 的 **请求配置**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/submitBill`
 * @更新时间 `2022-09-01 16:44:02`
 */
const submitBillRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ReturnProfitBill/submitBill",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: { type: "object", required: ["bill_id"], properties: { bill_id: { type: "string" } } },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "submitBill",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [账单详情-提交账单↗](http://yapi.yishou.com/project/128/interface/api/34106) 的 **请求函数**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/submitBill`
 * @更新时间 `2022-09-01 16:44:02`
 */
export const submitBill = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(submitBillRequestConfig, requestData), ...args);
};
submitBill.requestConfig = submitBillRequestConfig;
/**
 * 接口 [商家让利商品汇总列表↗](http://yapi.yishou.com/project/128/interface/api/34107) 的 **请求配置**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfit/listReturnProfitStats`
 * @更新时间 `2022-09-07 15:04:17`
 */
const listReturnProfitStatsRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ReturnProfit/listReturnProfitStats",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "stats_mouth[0]",
            "stats_mouth[1]",
            "supply_id",
            "supply_name",
            "goods_no",
            "goods_kh",
            "is_bill_generate",
            "page",
            "page_size",
            "is_excel",
        ],
        properties: {
            "stats_mouth[0]": { type: "string" },
            "stats_mouth[1]": { type: "string", description: "" },
            supply_id: { type: "string", description: "" },
            supply_name: { type: "string", description: "" },
            goods_no: { type: "string", description: "" },
            goods_kh: { type: "string", description: "" },
            is_bill_generate: { type: "string", description: "{1:出账，2：未出账}" },
            page: { type: "string", description: "分页" },
            page_size: { type: "string", description: "分页大小" },
            is_excel: { type: "string", description: "{0:不导出,1：导出}" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        supply_id: { type: "string", description: "供应商id" },
                        supply_name: { type: "string", description: "供应商名字" },
                        reporting_period: { type: "string", description: "汇总日期" },
                        goods_name: { type: "string", description: "供应商名字" },
                        goods_no: { type: "string", description: "供应商货号" },
                        goods_kh: { type: "string", description: "供应商款号" },
                        stats_sale_num: { type: "string", description: "符合让利的商品销售件数" },
                        updated_at: { type: "string", description: "更新时间" },
                        is_bill_generate_format: { type: "string", description: "是否出账" },
                    },
                    required: [
                        "supply_id",
                        "supply_name",
                        "reporting_period",
                        "goods_name",
                        "goods_no",
                        "goods_kh",
                        "stats_sale_num",
                        "updated_at",
                        "is_bill_generate_format",
                    ],
                },
            },
        },
    },
    requestFunctionName: "listReturnProfitStats",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [商家让利商品汇总列表↗](http://yapi.yishou.com/project/128/interface/api/34107) 的 **请求函数**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfit/listReturnProfitStats`
 * @更新时间 `2022-09-07 15:04:17`
 */
export const listReturnProfitStats = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(listReturnProfitStatsRequestConfig, requestData), ...args);
};
listReturnProfitStats.requestConfig = listReturnProfitStatsRequestConfig;
/**
 * 接口 [让利商品明细↗](http://yapi.yishou.com/project/128/interface/api/34108) 的 **请求配置**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @标签 `爆版4.28.0`
 * @请求头 `POST /erp/ReturnProfit/exportReturnProfitStatsDetail`
 * @更新时间 `2022-09-07 15:52:53`
 */
const exportReturnProfitStatsDetailRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ReturnProfit/exportReturnProfitStatsDetail",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id", "supply_name", "stats_mouth", "out_time[0]", "out_time[1]", "task"],
        properties: {
            supply_id: { type: "string", description: "供应商id" },
            supply_name: { type: "string", description: "供应商名称" },
            stats_mouth: { type: "string", description: "所属月" },
            "out_time[0]": { type: "string", description: "出库时间" },
            "out_time[1]": { type: "string", description: "出库时间" },
            task: { type: "string", description: "异步导出用的，前端写死1" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "exportReturnProfitStatsDetail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [让利商品明细↗](http://yapi.yishou.com/project/128/interface/api/34108) 的 **请求函数**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @标签 `爆版4.28.0`
 * @请求头 `POST /erp/ReturnProfit/exportReturnProfitStatsDetail`
 * @更新时间 `2022-09-07 15:52:53`
 */
export const exportReturnProfitStatsDetail = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exportReturnProfitStatsDetailRequestConfig, requestData), ...args);
};
exportReturnProfitStatsDetail.requestConfig = exportReturnProfitStatsDetailRequestConfig;
/**
 * 接口 [采购订单抵扣明细↗](http://yapi.yishou.com/project/128/interface/api/34109) 的 **请求配置**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/WcgOrder/listWoReturnProfitBillDetail`
 * @更新时间 `2022-09-02 14:07:30`
 */
const listWoReturnProfitBillDetailRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/WcgOrder/listWoReturnProfitBillDetail",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["woid"],
        properties: { woid: { type: "string", description: "采购订单" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        reporting_period: { type: "string", description: "让利账期" },
                        bill_no: { type: "string", description: "让利账单" },
                        confirm_time: { type: "string", description: "确认时间" },
                        amount_price: { type: "string", description: "总结算金额" },
                        deduction_price: { type: "string", description: "抵扣金额" },
                    },
                    required: ["reporting_period", "bill_no", "confirm_time", "amount_price", "deduction_price"],
                },
            },
            total: { type: "string", description: "让利抵扣金额" },
        },
    },
    requestFunctionName: "listWoReturnProfitBillDetail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [采购订单抵扣明细↗](http://yapi.yishou.com/project/128/interface/api/34109) 的 **请求函数**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/WcgOrder/listWoReturnProfitBillDetail`
 * @更新时间 `2022-09-02 14:07:30`
 */
export const listWoReturnProfitBillDetail = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(listWoReturnProfitBillDetailRequestConfig, requestData), ...args);
};
listWoReturnProfitBillDetail.requestConfig = listWoReturnProfitBillDetailRequestConfig;
/**
 * 接口 [账单抵扣明细↗](http://yapi.yishou.com/project/128/interface/api/34110) 的 **请求配置**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @标签 `爆版4.28.0`
 * @请求头 `POST /erp/SupplySettleBill/listSsbReturnProfitBillDetail`
 * @更新时间 `2022-09-06 19:39:00`
 */
const listSsbReturnProfitBillDetailRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/SupplySettleBill/listSsbReturnProfitBillDetail",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["bill_id"],
        properties: { bill_id: { type: "string", description: "采购账单id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        reporting_period: { type: "string", description: "账期" },
                        bill_no: { type: "string", description: "让利账单编号" },
                        confirm_time: { type: "string", description: "确认时间" },
                        amount_price: { type: "string", description: "总金额" },
                        deduction_price: { type: "string", description: "抵扣金额" },
                    },
                },
            },
            total: { type: "string", description: "总抵扣金额" },
        },
    },
    requestFunctionName: "listSsbReturnProfitBillDetail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [账单抵扣明细↗](http://yapi.yishou.com/project/128/interface/api/34110) 的 **请求函数**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @标签 `爆版4.28.0`
 * @请求头 `POST /erp/SupplySettleBill/listSsbReturnProfitBillDetail`
 * @更新时间 `2022-09-06 19:39:00`
 */
export const listSsbReturnProfitBillDetail = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(listSsbReturnProfitBillDetailRequestConfig, requestData), ...args);
};
listSsbReturnProfitBillDetail.requestConfig = listSsbReturnProfitBillDetailRequestConfig;
/**
 * 接口 [账单详情-重置规则↗](http://yapi.yishou.com/project/128/interface/api/34111) 的 **请求配置**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/resetRuleConfig`
 * @更新时间 `2022-09-01 20:31:26`
 */
const resetRuleConfigRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ReturnProfitBill/resetRuleConfig",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["bill_id", "remark"],
        properties: { bill_id: { type: "string" }, remark: { type: "string", description: "" } },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "resetRuleConfig",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [账单详情-重置规则↗](http://yapi.yishou.com/project/128/interface/api/34111) 的 **请求函数**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/resetRuleConfig`
 * @更新时间 `2022-09-01 20:31:26`
 */
export const resetRuleConfig = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(resetRuleConfigRequestConfig, requestData), ...args);
};
resetRuleConfig.requestConfig = resetRuleConfigRequestConfig;
/**
 * 接口 [账单详情-获取日志规则快照↗](http://yapi.yishou.com/project/128/interface/api/34112) 的 **请求配置**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/getLogSnapshot`
 * @更新时间 `2022-09-03 11:13:13`
 */
const getLogSnapshotRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ReturnProfitBill/getLogSnapshot",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["log_id"],
        properties: { log_id: { type: "string", description: "日志id   重新获取计费规则类型" } },
    },
    responseDataJsonSchema: {
        type: "array",
        items: {
            type: "object",
            properties: { num: { type: "string", description: "规则区间" }, price: { type: "string", description: "单价" } },
            required: ["num", "price"],
        },
    },
    requestFunctionName: "getLogSnapshot",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [账单详情-获取日志规则快照↗](http://yapi.yishou.com/project/128/interface/api/34112) 的 **请求函数**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/getLogSnapshot`
 * @更新时间 `2022-09-03 11:13:13`
 */
export const getLogSnapshot = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getLogSnapshotRequestConfig, requestData), ...args);
};
getLogSnapshot.requestConfig = getLogSnapshotRequestConfig;
/**
 * 接口 [账单详情-通过账单↗](http://yapi.yishou.com/project/128/interface/api/34113) 的 **请求配置**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/setExamineAdopt`
 * @更新时间 `2022-09-01 20:30:43`
 */
const setExamineAdoptRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ReturnProfitBill/setExamineAdopt",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["bill_id"],
        properties: { bill_id: { type: "string", description: "" } },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "setExamineAdopt",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [账单详情-通过账单↗](http://yapi.yishou.com/project/128/interface/api/34113) 的 **请求函数**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/setExamineAdopt`
 * @更新时间 `2022-09-01 20:30:43`
 */
export const setExamineAdopt = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(setExamineAdoptRequestConfig, requestData), ...args);
};
setExamineAdopt.requestConfig = setExamineAdoptRequestConfig;
/**
 * 接口 [账单详情-财务驳回↗](http://yapi.yishou.com/project/128/interface/api/34114) 的 **请求配置**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/setExamineReject`
 * @更新时间 `2022-09-01 20:29:42`
 */
const setExamineRejectRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ReturnProfitBill/setExamineReject",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["bill_id", "remark"],
        properties: { bill_id: { type: "string" }, remark: { type: "string", description: "" } },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "setExamineReject",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [账单详情-财务驳回↗](http://yapi.yishou.com/project/128/interface/api/34114) 的 **请求函数**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfitBill/setExamineReject`
 * @更新时间 `2022-09-01 20:29:42`
 */
export const setExamineReject = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(setExamineRejectRequestConfig, requestData), ...args);
};
setExamineReject.requestConfig = setExamineRejectRequestConfig;
/**
 * 接口 [补生成让利销售数据↗](http://yapi.yishou.com/project/128/interface/api/34117) 的 **请求配置**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfit/updateWcgOrder`
 * @更新时间 `2022-09-02 14:06:08`
 */
const updateWcgOrderRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ReturnProfit/updateWcgOrder",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id", "wcg_sub_time[0]", "wcg_sub_time[1]", "reserve_price", "out_time[0]", "out_time[1]"],
        properties: {
            supply_id: { type: "string", description: "商家ID" },
            "wcg_sub_time[0]": { type: "string", description: "代采单提交时间 (时间数组)" },
            "wcg_sub_time[1]": { type: "string", description: "代采单提交时间 (时间数组)" },
            reserve_price: { type: "string", description: "让利商品最低价" },
            "out_time[0]": { type: "string", description: "商品出库时间" },
            "out_time[1]": { type: "string", description: "商品出库时间" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "updateWcgOrder",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [补生成让利销售数据↗](http://yapi.yishou.com/project/128/interface/api/34117) 的 **请求函数**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfit/updateWcgOrder`
 * @更新时间 `2022-09-02 14:06:08`
 */
export const updateWcgOrder = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(updateWcgOrderRequestConfig, requestData), ...args);
};
updateWcgOrder.requestConfig = updateWcgOrderRequestConfig;
/**
 * 接口 [生成让利账单↗](http://yapi.yishou.com/project/128/interface/api/34118) 的 **请求配置**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfit/createBill`
 * @更新时间 `2022-09-02 14:07:19`
 */
const createBillRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ReturnProfit/createBill",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id", "reporting_period"],
        properties: {
            supply_id: { type: "string", description: "商家ID" },
            reporting_period: { type: "string", description: "账期 格式： 2022-08" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "createBill",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [生成让利账单↗](http://yapi.yishou.com/project/128/interface/api/34118) 的 **请求函数**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/ReturnProfit/createBill`
 * @更新时间 `2022-09-02 14:07:19`
 */
export const createBill = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(createBillRequestConfig, requestData), ...args);
};
createBill.requestConfig = createBillRequestConfig;
/**
 * 接口 [让利账单列表-初始化参数↗](http://yapi.yishou.com/project/128/interface/api/34120) 的 **请求配置**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `GET /erp/ReturnProfitBill/sectionInitOption`
 * @更新时间 `2022-09-05 16:59:07`
 */
const sectionInitOptionRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/ReturnProfitBill/sectionInitOption",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {
        type: "object",
        properties: {
            status: {
                type: "array",
                items: {
                    type: "object",
                    properties: { label: { type: "string" }, value: { type: "number" } },
                    required: ["label", "value"],
                },
                description: "状态",
            },
            clearing: {
                type: "array",
                items: {
                    type: "object",
                    properties: { label: { type: "string" }, value: { type: "number" } },
                    required: ["label", "value"],
                },
                description: "结算方式",
            },
        },
    },
    requestFunctionName: "sectionInitOption",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [让利账单列表-初始化参数↗](http://yapi.yishou.com/project/128/interface/api/34120) 的 **请求函数**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `GET /erp/ReturnProfitBill/sectionInitOption`
 * @更新时间 `2022-09-05 16:59:07`
 */
export const sectionInitOption = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(sectionInitOptionRequestConfig, requestData), ...args);
};
sectionInitOption.requestConfig = sectionInitOptionRequestConfig;
/**
 * 接口 [根据金钱去获取需要抵扣让利账单↗](http://yapi.yishou.com/project/128/interface/api/34121) 的 **请求配置**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/WcgOrder/listReturnProfitBillByAmount`
 * @更新时间 `2022-09-03 11:59:47`
 */
const listReturnProfitBillByAmountRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/WcgOrder/listReturnProfitBillByAmount",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["amount", "supply_id"],
        properties: {
            amount: { type: "string", description: "金额" },
            supply_id: { type: "string", description: "供应商id" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        rb_bill_id: { type: "number" },
                        bill_no: { type: "number" },
                        reporting_period: { type: "string" },
                        confirm_time: { type: "string" },
                        amount_price: { type: "string" },
                        already_ded_price: { type: "string" },
                        ded_price: { type: "string" },
                        remaining_ded_price: { type: "string" },
                    },
                    required: [],
                },
            },
        },
    },
    requestFunctionName: "listReturnProfitBillByAmount",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [根据金钱去获取需要抵扣让利账单↗](http://yapi.yishou.com/project/128/interface/api/34121) 的 **请求函数**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/WcgOrder/listReturnProfitBillByAmount`
 * @更新时间 `2022-09-03 11:59:47`
 */
export const listReturnProfitBillByAmount = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(listReturnProfitBillByAmountRequestConfig, requestData), ...args);
};
listReturnProfitBillByAmount.requestConfig = listReturnProfitBillByAmountRequestConfig;
/**
 * 接口 [判断是否有可抵扣的让利账单↗](http://yapi.yishou.com/project/128/interface/api/34128) 的 **请求配置**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/WcgOrder/getSupplyRpDed`
 * @更新时间 `2022-09-05 17:28:13`
 */
const getSupplyRpDedRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/WcgOrder/getSupplyRpDed",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: { type: "object", required: ["supply_id"], properties: { supply_id: { type: "string" } } },
    responseDataJsonSchema: {
        type: "object",
        properties: { is_return_profit_ded: { type: "integer", description: "是否有可用的抵扣让利账单:{0:否;1:是}" } },
        required: ["is_return_profit_ded"],
    },
    requestFunctionName: "getSupplyRpDed",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [判断是否有可抵扣的让利账单↗](http://yapi.yishou.com/project/128/interface/api/34128) 的 **请求函数**
 *
 * @分类 [爆版4.28(erp)↗](http://yapi.yishou.com/project/128/interface/api/cat_3461)
 * @请求头 `POST /erp/WcgOrder/getSupplyRpDed`
 * @更新时间 `2022-09-05 17:28:13`
 */
export const getSupplyRpDed = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getSupplyRpDedRequestConfig, requestData), ...args);
};
getSupplyRpDed.requestConfig = getSupplyRpDedRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/vendorProfitConcession3461.js